import type {
  StorefrontTagUpdateRequestType,
  StorefrontTagUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useStorefrontTagUpdate = (storefrontTagId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: StorefrontTagUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `storefront-tags/${storefrontTagId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as StorefrontTagUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontTags],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.StorefrontTags,
          storefrontTagId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
    },
  });
};
